module.exports = __webpack_public_path__ + "img/information-circle.c7c17374.svg";